import { autoinject } from "aurelia-framework";
import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/modules/list.constants";
import {
    SaveListRequest,
    ListModel,
    DeleteListRequest,
    SaveListItemRequest,
    DeleteListItemRequest,
    GetListItemResponse,
    ListAlertModel,
    SaveListAlertRequest,
    DeleteListAlertRequest,
    DeleteListItemResponse,
    DeleteListResponse
} from "../../models/lists/list.models";
import { BaseValidationResponse } from "../../models/validations/validations.models";
import { DeleteResponse } from "../../models/basics/basics.models";

@autoinject()
export class ListService {

    getCustomerLists(customerId: number): PromiseLike<ListModel[]> {
        return this.requestClient.get(Urls.GetCustomerLists, { customerId });
    }
    
    getBusinessUnitLists(businessUnitId: number): Promise<ListModel[]> {
        return this.requestClient.get(Urls.GetBusinessUnitLists, { businessUnitId });
    }

    constructor(private requestClient: RequestClientService) { }

    public getList(id: number): Promise<any> {
        return this.requestClient.get(Urls.GetList, { id });
    }

    public getAvailableLists(entityId: number, entityType: number): Promise<ListModel[]> {
        return new Promise<ListModel[]>((resolve, reject) => {
            this.requestClient.post<{lists:ListModel[]}>(Urls.GetAvailableLists, {}, { entityId, entityType }).then(response => {
                resolve(response.lists);
            }, e => {
                reject(e);
            });
        });
    }

    public saveList(request: SaveListRequest): Promise<BaseValidationResponse> {
        return new Promise<BaseValidationResponse>((resolve, reject) => {
            this.requestClient.post(Urls.SaveList, {}, request).then((response: BaseValidationResponse) => {
                if (response.validationResult && response.validationResult.hasError) {
                    reject(response);
                } else {
                    resolve(response);
                }
            }, (e) => {
                reject(e);
            });
        });
    }

    public deleteList(request: DeleteListRequest): Promise<DeleteListResponse> {
        return this.requestClient.post(Urls.DeleteList, {}, request);
    }

    public getListItem(id: number): Promise<GetListItemResponse> {
        return this.requestClient.get(Urls.GetListItem, { id });
    }

    public getListAlert(id: number): Promise<ListAlertModel> {
        return this.requestClient.get(Urls.GetListAlert, { id });
    }

    public saveListItem(request: SaveListItemRequest): Promise<BaseValidationResponse> {
        return new Promise<BaseValidationResponse>((resolve, reject) => {
            this.requestClient.post(Urls.SaveListItem, {}, request).then((response: BaseValidationResponse) => {
                if (response.validationResult && response.validationResult.hasError) {
                    reject(response);
                } else {
                    resolve(response);
                }
            }, (e) => {
                reject(e);
            });
        });
    }

    public saveListAlert(request: SaveListAlertRequest): Promise<BaseValidationResponse> {
        return new Promise<BaseValidationResponse>((resolve, reject) => {
            this.requestClient.post(Urls.SaveListAlert, {}, request).then((response: BaseValidationResponse) => {
                if (response.validationResult && response.validationResult.hasError) {
                    reject(response);
                } else {
                    resolve(response);
                }
            }, (e) => {
                reject(e);
            });
        });
    }

    public deleteListItem(request: DeleteListItemRequest): Promise<DeleteListItemResponse> {
        return this.requestClient.post(Urls.DeleteListItem, {}, request);
    }
    public deleteListAlert(request: DeleteListAlertRequest): Promise<DeleteResponse> {
        return new Promise<DeleteResponse>((resolve, reject) => {
            this.requestClient.post(Urls.DeleteListAlert, {}, request).then((response: DeleteResponse) => {
                resolve(response);
            }, (e) => {
                reject(e);
            });
        });
    }

    public exportList(id: number, name) {
        return this.requestClient.get<Blob>(`${Urls.ExportList}/${id}`, {}, ResponseType.Blob).then(x => {
            this.requestClient.downloadFile(x, name + ".xlsx");
        }, e => { throw e; });
    }
}